import { useEffect, useState } from 'react'
import type { UserSubscriptionDetailFragment } from 'src/services/apollo/generated/graphql'
import { useMyMembership } from 'src/services/apollo/membership'
import { UserSubscriptionStatus } from 'src/utils/user'

function getSubscriptionTier(sub: UserSubscriptionDetailFragment | undefined) {
  if (sub?.status === UserSubscriptionStatus.active) {
    return sub.tier ?? 0
  }
  return 0
}

/**
 * Manage the "preview tier" UI state — what tier the user is previewing
 * boosts at, separate from their actual membership tier.
 *
 * Initialized from the user's actual tier and re-syncs whenever it
 * changes (e.g. after a successful subscription).
 */
export function useSelectedTier() {
  const { data: { membership, subscription } = {} } = useMyMembership()
  const [selectedTier, setSelectedTier] = useState(
    getSubscriptionTier(subscription),
  )
  useEffect(() => {
    if (membership?.tier != null) {
      setSelectedTier(membership.tier)
    }
  }, [membership?.tier])

  return {
    selectedTier,
    setSelectedTier,
    currentTier: membership?.tier ?? 0,
    actualTier: getSubscriptionTier(subscription),
  }
}
